import {
  Slot,
  component$,
  useStore,
  useContextProvider,
  createContextId,
  $,
} from "@builder.io/qwik";
import type {
  ConfigDataActionType,
  ConfigDataContextType,
} from "../types/ConfigDataContextType";

const initData: ConfigDataContextType = {
  decimal: 0,
  characterFontWidth: 7.8,
  canvasWidth: 0,
  mainCanvasHeight: 0,
  rangeSelectorRealHeight: 0,
  emptySpaceFromBottomPercent: 12 / 100,
  emptySpaceFromTopPercent: 12 / 100,
  emptySpaceFromBottomPercentRS: 2 / 100,
  emptySpaceFromTopPercentRS: 2 / 100,
  chartHeight: 0,
  pan: false,
  isMobile: false,
};

export const ConfigDataContext =
  createContextId<ConfigDataContextType>("ConfigDataContext");
export const ConfigDispatchContext = createContextId<
  (action: ConfigDataActionType) => void
>("ConfigDispatchContext");

function dataReducer(
  state: ConfigDataContextType,
  action: ConfigDataActionType,
) {
  if (action.type === "changeDiagramDimension") {
    state.canvasVolumeHeightPercent = action.canvasVolumeHeightPercent;
    state.canvasVolumeHeightShiftPercent =
      action.canvasVolumeHeightShiftPercent;
    state.canvasMACDHeightPercent = action.canvasMACDHeightPercent;
    state.canvasMACDHeightShiftPercent = action.canvasMACDHeightShiftPercent;
    state.mainCanvasHeight = action.mainCanvasHeight;
    state.emaCanvasHeight = action.emaCanvasHeight;
    state.macdCanvasHeight = action.macdCanvasHeight;
    state.rsiCanvasHeight = action.rsiCanvasHeight;
    state.volumeCanvasHeight = action.volumeCanvasHeight;
    state.canvasWidth = action.canvasWidth;
    state.chartHeight = action.chartHeight;
    state.dateCanvasHeight = action.dateCanvasHeight;
    state.rangeSelectorRealHeight = action.rangeSelectorRealHeight;
  } else if (action.type === "changeDecimal") {
    state.decimal = action.decimal;
  } else if (action.type === "changePan") {
    state.pan = action.pan;
  } else if (action.type === "changeIsMobile") {
    state.isMobile = action.isMobile;
  }
}

export const ConfigDataProvider = component$(() => {
  const data = useStore({ ...initData });
  const dispatch = $((action: ConfigDataActionType) => {
    dataReducer(data, action);
  });
  useContextProvider(ConfigDataContext, data);
  useContextProvider(ConfigDispatchContext, dispatch);
  return <Slot />;
});

export const getConfigData = ConfigDataContext;
export const getConfigDispatch = ConfigDispatchContext;
